import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X } from 'lucide-react';
import { useI18n } from '@/lib/i18n';
import logo from '@/assets/kostya_logo.svg';
const Header = () => {
  const {
    lang,
    setLang,
    t
  } = useI18n();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [adddOpen, setAdddOpen] = useState(false);
  const [tenKOpen, setTenKOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const links = [{
    href: '/about',
    label: t('Обо мне', 'About'),
    isPage: true
  }, {
    href: '/portfolio',
    label: t('Работы', 'Works'),
    isPage: true
  }, {
    href: 'https://t.me/sinnerkot_talks',
    label: t('Блог', 'Blog'),
    isPage: false,
    isExternal: true
  }, {
    href: '#addd',
    label: t('ADDD', 'ADDD'),
    isPage: false,
    isModal: true,
    modalId: 'addd'
  }, {
    href: '#10k',
    label: '10K',
    isPage: false,
    isModal: true,
    modalId: '10k'
  }, {
    href: '#contact',
    label: t('Связаться', 'Contact'),
    isPage: false
  }];
  const handleClick = (link: typeof links[0]) => {
    setMobileOpen(false);
    if ('isModal' in link && link.isModal) {
      if ('modalId' in link && link.modalId === '10k') {
        setTenKOpen(true);
      } else {
        setAdddOpen(true);
      }
    } else if ('isExternal' in link && link.isExternal) {
      window.open(link.href, '_blank', 'noopener,noreferrer');
    } else if (link.isPage) {
      navigate(link.href);
    } else {
      if (location.pathname !== '/') {
        navigate('/' + link.href);
      } else {
        const el = document.querySelector(link.href);
        el?.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };
  return <><header className="fixed top-0 left-0 right-0 z-50 border-b border-border/50 backdrop-blur-xl bg-[#0522ff]">
      <div className="container flex items-center justify-between h-16 md:h-20">
        <a href="/" className="flex items-center">
          <img src={logo} alt="Logo" className="h-6 md:h-7" />
        </a>

        {/* Desktop nav */}
        <nav className="hidden md:flex items-center gap-8 bg-black/40 backdrop-blur-md rounded-xl px-6 py-3">
          {links.map(link => <button key={link.href} onClick={() => handleClick(link)} className="text-sm font-medium text-[#f3f6f7] hover:text-[#9aff03] transition-colors">
              {link.label}
            </button>)}
          <button onClick={() => setLang(lang === 'ru' ? 'en' : 'ru')} className="px-3 py-1 text-xs font-display font-bold border border-[#f3f6f7]/30 rounded-full text-[#f3f6f7] hover:bg-[#9aff03] hover:text-primary-foreground hover:border-[#9aff03] transition-all">
            {lang === 'ru' ? 'EN' : 'RU'}
          </button>
        </nav>

        {/* Mobile toggle */}
        <button className="md:hidden text-foreground" onClick={() => setMobileOpen(!mobileOpen)}>
          {mobileOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile menu */}
      <AnimatePresence>
        {mobileOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden border-t border-border bg-background">
            <nav className="container flex flex-col gap-4 py-6">
              {links.map(link => <button key={link.href} onClick={() => handleClick(link)} className="text-lg font-display text-left text-foreground">
                  {link.label}
                </button>)}
              <button onClick={() => setLang(lang === 'ru' ? 'en' : 'ru')} className="w-fit px-4 py-2 text-sm font-display font-bold border border-primary/30 rounded-full text-primary">
                {lang === 'ru' ? 'English' : 'Русский'}
              </button>
            </nav>
          </motion.div>}
      </AnimatePresence>
    </header>

    {/* ADDD Modal */}
    <AnimatePresence>
      {adddOpen && (
        <>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-[60] bg-black/70 backdrop-blur-sm"
            onClick={() => setAdddOpen(false)}
          />
          <motion.div
            initial={{ opacity: 0, scale: 0.95, y: -20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.95, y: -20 }}
            transition={{ type: 'spring', damping: 25, stiffness: 300 }}
            className="fixed z-[70] inset-0 flex items-center justify-center pointer-events-none"
          >
            <div className="pointer-events-auto w-[90vw] max-w-2xl bg-secondary border border-border rounded-2xl p-8 shadow-2xl text-center relative">
            <button
              onClick={() => setAdddOpen(false)}
              className="absolute top-4 right-4 text-muted-foreground hover:text-foreground transition-colors"
            >
              <X size={20} />
            </button>
            <h3 className="text-xl font-display font-bold text-foreground mb-4">ADDD</h3>
            <p className="text-muted-foreground leading-relaxed mb-6">
              {t(
                'Art Direction Deep Dive (ADDD) представляет собой тщательно составленный набор учебных пособий, посвящённых арт-дирекшену. Материалы разработаны для подготовки специалистов высочайшего уровня.',
                'Art Direction Deep Dive (ADDD) is a carefully curated set of tutorials dedicated to art direction. The materials are designed to train top-level specialists.'
              )}
            </p>
            <a
              href="https://artdirectiondeepdive.com"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block w-full px-6 py-3 rounded-xl bg-primary text-primary-foreground font-display font-medium hover:opacity-90 transition-opacity"
            >
              {t('Перейти', 'Go')}
            </a>
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>

    {/* 10K Modal */}
    <AnimatePresence>
      {tenKOpen && (
        <>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-[60] bg-black/70 backdrop-blur-sm"
            onClick={() => setTenKOpen(false)}
          />
          <motion.div
            initial={{ opacity: 0, scale: 0.95, y: -20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.95, y: -20 }}
            transition={{ type: 'spring', damping: 25, stiffness: 300 }}
            className="fixed z-[70] inset-0 flex items-center justify-center pointer-events-none"
          >
            <div className="pointer-events-auto w-[90vw] max-w-2xl bg-secondary border border-border rounded-2xl p-8 shadow-2xl text-center relative">
            <button
              onClick={() => setTenKOpen(false)}
              className="absolute top-4 right-4 text-muted-foreground hover:text-foreground transition-colors"
            >
              <X size={20} />
            </button>
            <h3 className="text-xl font-display font-bold text-foreground mb-4">10.000 References</h3>
            <p className="text-muted-foreground leading-relaxed mb-6">
              {t(
                '10.000 References - мой проект направленный на расширение насмотренности. В течение многих лет я тщательно отбираю выдающиеся проекты из различных областей и делюсь ими с вами.',
                '10,000 References is my project aimed at expanding visual awareness. For many years, I have been carefully selecting outstanding projects from various fields and sharing them with you.'
              )}
            </p>
            <a
              href="https://10000refs.me/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block w-full px-6 py-3 rounded-xl bg-primary text-primary-foreground font-display font-medium hover:opacity-90 transition-opacity"
            >
              {t('Перейти', 'Go')}
            </a>
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  </>;
};
export default Header;